import React, { useCallback, useEffect } from 'react'

import Dialog, { holding } from './Dialog'
import Form from '../../Form'
import FormMessage from '../../FormMessage'
import { getUuid } from '../../..'
import { useInstData, useDelayTimer } from 'tyan/public/hooks'
import FetchSpinner from './FetchSpinner'
// require('../../../tyanInit')

const DialogForm = (props) => {
	return <Form {...props} isDialog={true} />
}

const DialogFormMessage = (props) => {
	return <FormMessage {...props} isDialog={true} />
}

const DialogGroup = props => {
	const { newDelay: delayShowFetchSpinner, stopDelay: stopDelayShowFetchSpinner } = useDelayTimer(Tyan.appSettings.config.fetchSpinnerDelay || 50)
	const { setState, me, me: { state: { dialogs, masked, showFetchSpinner } } } = useInstData(props, useCallback(() => {
		Tyan.fetchBegin = () => {
			me.fetchCount += 1
			if (!me.fetchSpinnerShowing && !me.state.showFetchSpinner) {
				me.fetchSpinnerShowing = true
				delayShowFetchSpinner(() => {
					me.fetchSpinnerShowing = false
					setState({ showFetchSpinner: true })
				})
			}
		}
		Tyan.fetchEnd = () => {
			me.fetchCount = Math.max(0, me.fetchCount - 1)
			if (!me.fetchCount) {
				if (me.fetchSpinnerShowing) {
					stopDelayShowFetchSpinner()
					me.fetchSpinnerShowing = false
				}
				me.state.showFetchSpinner && setState({ showFetchSpinner: false })
			}
		}
		return { state: { dialogs: [], masked: null, showFetchSpinner: false, }, fetchCount: 0, fetchSpinnerShowing: false }
	}, []))

	useEffect(() => {
		return () => {
			Tyan.fetchBegin = () => { }
			Tyan.fetchEnd = () => { }
		}
	}, [])

	const handleClose = useCallback(dlg => dialogs.includes(dlg) && dialogs.splice(dialogs.indexOf(dlg), 1) && setState({}))

	const doShowDialog = useCallback(dlg => {
		if (holding.holding) {
			setTimeout(() => doShowDialog(dlg))
			return
		}
		holding.holding = true
		dialogs.push(dlg)
		setState({})
	}, [])

	useEffect(() => {
		Tyan.pubForm.showDialog = (title, component, compProps = {}, dialogProps = {}) => {
			if (!component) {
				Tyan.pubForm.showError("没有组件用于显示对话框")
				return {}
			}
			const dlg = { title, key: getUuid(), component, compProps: { showBody: DialogForm, showMessage: DialogFormMessage, ...compProps }, dialogProps }
			dlg.onClose = () => handleClose(dlg)
			doShowDialog(dlg)
			return { closeDialog: () => (dlg.dialogProps.closeMe = true, setState({})) }
		}
		Tyan.pubForm.mask = masked => setState({ masked: masked || null })

		return () => (delete Tyan.pubForm.showDialog, delete Tyan.pubForm.mask)
	}, [])

	// 如果当前页面为 #/login，关闭所有对话框
	// const { token } = Tyan.loginInfo || {}
	let { hash } = window.location
	hash = (hash || '').toLowerCase()
	hash === '#/login' && dialogs.length && !dialogs[dialogs.length - 1].dialogProps.closeMe
		&& (dialogs[dialogs.length - 1].dialogProps.closeMe = true, setTimeout(() => setState({})))

	Ext.Viewport.setMasked(dialogs.length ? false : masked)
	const lastOne = dialogs.length - 1
	// console.log('Dialog group render:', dialogs.length, dialogs, holding, Tyan.loginInfo)
	return <>
		<FetchSpinner showMe={!dialogs.length && showFetchSpinner} />
		{dialogs.map((o, i) => <Dialog key={o.key} title={o.title} component={o.component} onClose={o.onClose}
			compProps={o.compProps} dialogProps={{ ...o.dialogProps, ...(i === lastOne ? { masked, showFetchSpinner } : {}) }} />)}
	</>
}

export default DialogGroup